<script setup lang="ts">
import type { AccordionItem, AccordionProps } from '#ui/components/Accordion.vue'

interface VAccordionProps {
  items: AccordionItem[]
  unmountOnHide?: boolean
}

const props = defineProps<VAccordionProps>()
</script>

<template>
  <UAccordion
    type="multiple"
    :items
    :ui="{
      trigger: 'cursor-pointer',
      content: 'max-w-section',
      body: 'text-base',
      item: 'border-dark-green dark:border-gray-500 border-b',
      trailingIcon: 'size-10 text-dark-green dark:text-success',
      label: 'paragraph-title my-0'
    }"
    :unmount-on-hide
  >
    <template #default="{ item }">
      <slot name="default" :item="item" />
    </template>

    <template #content="{ item }">
      <slot name="content" :item="item" />
    </template>
  </UAccordion>
</template>

<style scoped></style>
